import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

function Cancel() {
  return (
    <div>
        <Header></Header>
        <h1 style={{ marginTop: '68px' }}>Cancel/ Refund policies</h1>
        <Footer></Footer>
    </div>
  )
}

export default Cancel